import React, { useEffect, useState } from "react";
import BookingOverviewTable from "./bookingOverview";
import SearchForm from "../../component/search-form";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import LimitAlert from "../../component/Alert/LimitAlert";
// Import redux
import { useDispatch, useSelector } from "react-redux";
import {
  checkPlanDetails,
  getBookingFieldList,
  exportBookingTableData,
} from "../../redux/actions/booking";
import { RESET_SAVE_TEMPORARY_DATA, SET_PREVIOUS_PATH } from "../../redux/constants";
import moment from "moment";
import { Customer } from "../../constant/AuthenticationConstant";
import { sanitizeInput } from "../../utils";
import QuickBookingModal from "./quickBookingModal";

const Booking = () => {
  // Creating state to store search value
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState();
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [billingDetails, setBillingDetails] = useState("");
  const { tempPageName } = useSelector((state) => state.tempWindowsData);
  const { bookingList } = useSelector((state) => state.booking);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const { planDetail } = useSelector((state) => state.booking);
  const { row_count } = useSelector((state) => state.auth);
  const isCustomer = user.type === Customer;

  const [openQuickBooking, setOpenQuickBooking] = useState(false);

  const getPlanDetails = () => {
    if (["super-admin", "admin"].includes(user?.type)) {
      const request = {
        onError: () => {},
        data: {
          company_id: user?.company?.id,
          current_plan_id: user?.company?.current_plan_id,
        },
      };

      dispatch(checkPlanDetails(request));
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_API_URL}/billing_details`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        if (result.data?.data?.length !== 0) {
          setBillingDetails(result.data.data[0]);
        }
      } catch (error) {}
    })();
    getPlanDetails();
    dispatch({type: SET_PREVIOUS_PATH, payload: location.pathname.toString()})
  }, []);

  const handleExport = () => {
    dispatch(
      exportBookingTableData(searchText, page, row_count, sortField, sortOrder)
    );
  };

  return (
    <>
      {/* <div className="sm:mx-6 lg:mx-8">{planDetail && <LimitAlert />}</div> */}
      {/* { !billingDetails && <BillingDetailsAlert /> } */}
      <div className="mt-4 sm:mx-6 lg:mx-8 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
                  {bookingList?.totalCount}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;Bookings
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                in Total
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
                  {bookingList?.bookingCount}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;Bookings
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                in {moment(new Date()).format("MMMM")}{" "}
                {new Date().getFullYear()}
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
                  {bookingList?.pendingAssignments}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;Bookings
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                with Pending Assignment
              </p>
            </div>
          </div>
          <div className="h-[90px] bg-[--bg-color-50] rounded flex justify-center items-center">
            <div className="w-[80%]">
              <div>
                <span className="text-[--bg-color-500] text-2xl leading-6 font-semibold">
                  {bookingList?.completedAssignments}
                </span>
                <span className="text-[13px] leading-[13px] font-medium text-[#858585]">
                  &nbsp;Bookings
                </span>
              </div>
              <p className="text-[#313439] text-sm leading-3 font-medium">
                Completed Bookings
              </p>
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
            <div className="space-x-4 flex items-center">
              <h4 className="text-xl leading-5 font-bold tracking-tight">
                Booking List
              </h4>
              <SearchForm
                placeholder="Search"
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  setSearchText(value);
                }}
                value={searchText}
              />
              <button
                className="btn bg-[--bg-color-500] text-white"
                onClick={handleExport}
              >
                Export
              </button>
            </div>
            {!isCustomer && (
              <div className="flex flex-row items-center justify-end">
                {
                  user?.company?.is_subscribed_visibility && user?.company?.id === process.env?.REACT_APP_VISIBILITY_COMPANY_ID && (
                  <div className="space-x-4 flex items-center justify-end">
                    <button
                      className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                      onClick={() => {
                        setOpenQuickBooking(true);
                      }}
                    >
                      <span className={`fa-solid fa-bolt mr-2`}></span>
                      Quick Booking
                    </button>
                  </div>
                  )
                }
                <div className="space-x-4 flex items-center justify-end">
                  {/* <CheckboxFilter button checkoxData={checkoxData} /> */}
                  <button
                    className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                    onClick={() => {
                      if (tempPageName === "bookings") {
                        dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
                      }
                      navigate(`/booking/create`);
                    }}
                  >
                    <span className={`fas fa-plus mr-2`}></span>
                    Create New Booking
                  </button>
                </div>
              </div>
            )}
          </div>
          <BookingOverviewTable
            searchText={searchText}
            page={page}
            setPage={setPage}
            sortField={sortField}
            setSortField={setSortField}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
          />
          <QuickBookingModal modalOpen={openQuickBooking} setModalOpen={setOpenQuickBooking} />
        </div>
      </div>
    </>
  );
};

Booking.auth = {
  path: "/booking/overview",
  role: "super-admin admin customer",
};
export default Booking;
